import find from "lodash/find";
import remove from "lodash/remove";
import messagesQuery from "../queries/messagesQuery";
import createApolloMessage from "./createApolloMessage";

/**
 * writeMessageToApolloCache handles filtering out the optimistic chat message
 * and inserting response from the pusher websocket in to the apollo cache
 * while preventing creating duplicates.
 *
 * @export
 * @param {*} message
 * @param {*} client
 */
export default function writeMessageToApolloCache(message, client, queryVariables) {
    const apolloMessageData = createApolloMessage(message);
    const data = client.readQuery({
        query: messagesQuery,
        variables: {
            chatGroupId: message.chatGroupId,
            ...queryVariables,
        },
    });

    // filter out optimistic msg since socket message could arrive
    // before the mutation result has removed the optimistic messages
    remove(data.messages.messages, (m) => m.id.indexOf("optimistic") !== -1);

    // ignore message which are already in the store (sent by me)
    const messageExists = find(data.messages.messages, {
        id: apolloMessageData.id,
    });

    if (!messageExists) {
        // Add our message from the websocket to the end.
        data.messages.messages.push(apolloMessageData);
        // Write our data back to the cache.
        client.writeQuery({
            query: messagesQuery,
            variables: {
                chatGroupId: message.chatGroupId,
                ...queryVariables,
            },
            data,
        });
    }
}

